import { HamburgerMenu } from '../components/HamburgerMenu';
import { VisitUs } from '../components/VisitUs';
import { NewsletterSignup } from '../components/NewsletterSignup';
import { SEO } from '../components/SEO';
export function Location() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-[#D97E3A] selection:text-white" data-id="element-513" data-mp="5l67uhpv5ikk">
      <SEO title="Visit Grounded - Coffee Shop in Livermore, CA" description="Grounded is at 53 Wright Brothers Ave, Ste A, Livermore, CA 94551. Open daily 7:00 AM – 2:00 PM with free parking. Call (925) 292-0433 or get directions." canonical="https://www.groundedlivermore.com/location" data-id="element-514" data-mp="aieqskiu5qmv" />
      <HamburgerMenu data-id="element-515" data-mp="3j0ueuz025hm5" />

      <main data-id="element-516" data-mp="3nxkrtdgkfx3c">
        <VisitUs headingLevel="h1" data-id="element-517" data-mp="3nydr5td73kbg" />
        <NewsletterSignup data-id="element-518" data-mp="3nzfeoxbedza2" />

        <footer className="border-t border-white/10 py-12 text-center" data-id="element-519" data-mp="3nvhsu3xfqtmh">
          <p className="font-bebas text-2xl text-white/50" data-id="element-520" data-mp="y80lauo9jhoj">
            © {new Date().getFullYear()} GROUNDED LIVERMORE
          </p>
        </footer>
      </main>
    </div>;
}